module.exports = __webpack_public_path__ + "img/PGR_A03_front_en.1d8ead7f.png";